import { Link, useParams } from "react-router-dom";
import Seo, { breadcrumbLd } from "../lib/seo";
import { SOLUTIONS, PRODUCTS } from "../data/content";
import { Breadcrumbs } from "../components/site/Layout";
import { PageHero, CtaBand, RelatedGrid } from "../components/site/Sections";
import { Reveal, Overline } from "../components/site/Reveal";
import NotFound from "./NotFound";

export function Solutions() {
  return (
    <>
      <Seo title="Product Authentication & Anti-Counterfeit Solutions in UAE | NanoMax"
        description="Anti-counterfeit, product authentication, brand protection, tamper evidence and QR verification solutions for businesses across the UAE."
        path="/solutions" jsonLd={breadcrumbLd([{ name: "Home", path: "/" }, { name: "Solutions", path: "/solutions" }])} />
      <Breadcrumbs items={[{ name: "Home", path: "/" }, { name: "Solutions" }]} />
      <PageHero overline="Solutions" title="Product Authentication & Anti-Counterfeit Solutions in UAE"
        subtitle="Layered security solutions that help UAE brands protect products, verify authenticity and strengthen trust." />
      <section className="px-6 md:px-10 lg:px-16 py-20 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {SOLUTIONS.map((s, i) => (
          <Reveal key={s.slug} delay={i * 0.04}>
            <Link to={`/solutions/${s.slug}`} className="card p-7 h-full block group" data-testid={`solution-card-${i}`}>
              <h2 className="font-head text-xl font-semibold group-hover:text-holo-cyan transition-colors">{s.name}</h2>
              <p className="text-sm text-[#8A8A9B] mt-3 leading-relaxed">{s.tile}</p>
              <span className="link-arrow mt-5 inline-flex">Explore {s.name} <span aria-hidden>&rarr;</span></span>
            </Link>
          </Reveal>
        ))}
      </section>
      <CtaBand sourcePage="/solutions" />
    </>
  );
}

export function SolutionDetail() {
  const { slug } = useParams();
  const s = SOLUTIONS.find((x) => x.slug === slug);
  if (!s) return <NotFound />;
  const path = `/solutions/${s.slug}`;
  return (
    <>
      <Seo title={`${s.name} in UAE | NanoMax Holo Solutions`} description={s.desc} path={path}
        jsonLd={breadcrumbLd([{ name: "Home", path: "/" }, { name: "Solutions", path: "/solutions" }, { name: s.name, path }])} />
      <Breadcrumbs items={[{ name: "Home", path: "/" }, { name: "Solutions", path: "/solutions" }, { name: s.name }]} />
      <PageHero overline="Security Solution" title={`${s.name} in UAE`} subtitle={s.desc} />
      <section className="px-6 md:px-10 lg:px-16 py-16">
        <Reveal>
          <div className="card p-8 max-w-3xl">
            <Overline>How it helps</Overline>
            <p className="text-base md:text-lg text-[#8A8A9B] mt-4 leading-relaxed">{s.desc} Combined with the right materials, artwork and verification method, {s.name.toLowerCase()} form part of a layered security approach tailored to your product and the UAE market.</p>
          </div>
        </Reveal>
      </section>
      <RelatedGrid title="Related Products" items={PRODUCTS.slice(0, 4).map((x) => ({ name: x.name, desc: x.tile, to: `/products/${x.slug}` }))} />
      <CtaBand sourcePage={path} />
    </>
  );
}
